<template>
        <v-card
                elevation="0"
                color="#f4f5f6"
                class="fixed-bottom px-2"
        >
            <v-row class="justify-space-between px-2 d-xs-flex d-md-none">
                <v-col class="px-1">
                    <v-btn
                        color="primary"
                        height="45"
                        class="btn-edurent"
                        depressed
                        block
                        @click="isUserLoggedIn ? $vuetify.goTo('#contactProperty') : openSignIn()"
                    >
                        Email
                    </v-btn>
                </v-col>
                <v-col class="px-1">
                    <v-btn
                        color="not-selected"
                        height="45"
                        class="btn-edurent"
                        depressed
                        block
                        @click="onPropertyContact()"
                    >
                        Call
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
</template>
<script>
import PropertyService from '../services/property.service'

export default {
    name: 'MobileContact',
    props: {
        property: {
            type: Object,
            required: true
        }
    },
    computed: {
        user() {
            return this.$store.getters.getUser;
        },
        isUserLoggedIn() {
            return this.$store.getters.isUserLoggedIn
        },
    },
    methods: {
        openSignIn() {
            this.$store.dispatch('setSignInModal', true)
        },
        onPropertyContact() {
            if (!this.isUserLoggedIn) {
                this.$store.dispatch('setSignInModal', true);

                return;
            }

            const contactProperty = document.getElementById('contactProperty')
            if (contactProperty) {
                window.scrollTo({
                    top: contactProperty.offsetTop,
                    behavior: 'smooth'
                })
            }

            const phoneNumber = this.property.phone_number.replace(/\D/g, '');
            if (phoneNumber.length !== 0) {
                window.location.href = 'tel://' + phoneNumber;
            }

            PropertyService.referStudentToProperty(this.user.id, {
                data: {
                    propertyId: this.property.id,
                    includeRoommates: true,
                    sender: 'student'
                }
            })
        },
    }
}
</script>
<style>
    .fixed-bottom {
        position:fixed;
        left:0;
        bottom:0;
        z-index: 5;
        width: 100%;
    }
</style>
